import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Table, Label, Icon, Popup } from 'semantic-ui-react'
import { Pagination, SortIcon } from '../components'
import { roles, courseTypesFormated } from '../../common/config'

const { Header, Body, Row, Cell, HeaderCell, Footer } = Table

const sortIcons = {
  ascending: <SortIcon ascending />,
  descending: <SortIcon descending />,
  sort: <SortIcon />,
}

const getRecordIcon = (r) => {
  if (!!r.archived || r.state == 'ARCH') {
    return <Icon name="trash" color="red" size="large" />
  }
  else if (r.state == 'NEW' || r.state == 'PREV') {
    return <Icon name="tablet" color="orange" size="large" />
  }
  else {
    return <Icon name="edit" color="green" size="large" />
  }
}

const getRecordTag = (r) => {
  if (!!r.archived || r.state == 'ARCH') {
    return <Label color="red" size="big">Koš</Label>
  }
  else if (r.state == 'NEW' || r.state == 'PREV') {
    return <Label color="orange" size="big">Plán</Label>
  }
  else {
    return <Label color="green" size="big">OK</Label>
  }
}

const AttendancesTable = ({
  attendances, meta, list, viewer: { role, tokens }, waitingForDownload, getCSV, csv, clearDownload,
}) => {
  const paging = list.$paging(meta.count)
  return (
    <Table className="attendances">
      <Header>
        <Row>
		      <HeaderCell className="cell-with-icon" />
          <HeaderCell className="cell-with-icon" />
          <HeaderCell>{list.$heading('companyNameSort', 'Dopravce', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('courseType', 'Typ', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('date', 'Datum', sortIcons)}</HeaderCell>
          {false && <HeaderCell className="cell-with-icon" />}
          <HeaderCell>{list.$heading('locationNameSort', 'Lokace', sortIcons)}</HeaderCell>
          <HeaderCell>Počet účastníků</HeaderCell>
          <HeaderCell />
          <HeaderCell />
        </Row>
      </Header>
      <Body>
        {attendances.map((a) => (
          <Row key={a._id} style={a.archived ? {background:'#ffeaea'} : {}}>
            <Cell className="cell-with-icon">{('' + a.note).length > 0 && <Popup trigger={<Icon name="info" />} content={a.note} position="right center" />}</Cell>
            <Cell className="cell-with-icon">{a.feedbacksPdf.length > 0 && <Popup trigger={<Icon name="comments" color="olive" size="large" />} content="obsahuje zpětné vazby řidičů" position="right center" />}</Cell>
			<Cell>{a.companyName}</Cell>
            <Cell>{courseTypesFormated[a.courseType].name}</Cell>
            <Cell>{moment(a.date).format('D.M.YYYY')}</Cell>
            {false && <Cell className="cell-with-icon">{getRecordTag(a)}</Cell>}
            <Cell>{a.locationName}</Cell>
            <Cell>{a.drivers.length}</Cell>
            <Cell><a href={`/api/v1/attendances/${a._id}/pdf?token=${tokens.access}`} rel="noopener noreferrer" target="_blank"> PDF</a></Cell>
            <Cell><Link to={`/attendances/${a._id}`}>Zobrazit</Link></Cell>
          </Row>
        ))}
      </Body>
      <Footer>
        <Row>
          <Cell colSpan={role === roles.SUPERVISOR ? 7 : 6}>
            {`
              Zobrazeno
              ${Math.min(((meta.currentPage - 1) * 100) + 1, meta.count)}
              -
              ${Math.min((meta.currentPage * 100) + 1, meta.count)} z ${meta.count}
            `}
            {(getCSV || csv) && <span>-&nbsp;</span>}
            {getCSV && !csv &&
              <span className="downloadCSV">
                {waitingForDownload
                  ? <Icon loading name="spinner" />
                  : <a onClick={getCSV}>Stáhnout CSV</a>
                }
              </span>
            }
            {csv &&
              <a href={csv} rel="noopener noreferrer" target="_blank" onClick={clearDownload}>
                CSV připraveno, klikněte pro stažení
              </a>
            }
          </Cell>
          <Cell colSpan={2}><Pagination paging={paging} /></Cell>
        </Row>
      </Footer>
    </Table>
  )
}

AttendancesTable.defaultProps = {
  getCSV: null,
  waitingForDownload: false,
  csv: '',
}

AttendancesTable.propTypes = {
  attendances: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  list: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  getCSV: React.PropTypes.any,
  waitingForDownload: React.PropTypes.bool,
  clearDownload: React.PropTypes.func.isRequired,
  csv: React.PropTypes.string,
}

export default AttendancesTable



// WEBPACK FOOTER //
// ./src/browser/tables/Attendances.js